import { render, staticRenderFns } from "./ItemListPremiumMarketLayout.vue?vue&type=template&id=c7f1916e&scoped=true"
import script from "./ItemListPremiumMarketLayout.vue?vue&type=script&lang=js"
export * from "./ItemListPremiumMarketLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f1916e",
  null
  
)

export default component.exports